<template>
  <my-dialog
    @hideMask="closeModal"
    :dialogFlag="dialogFlagForDelete"
    width="330px"
    p_lr="0"
  >
    <div class="dialog_inner_container_for_delete">
      <div class="dialog_inner_container_for_delete_header">提示</div>
      <div class="dialog_inner_container_for_delete_body">
        {{ tipMsg }}
      </div>
      <div class="dialog_inner_container_for_delete_footer">
        <div
          :class="[
            'dialog_inner_container_for_delete_footer_inner_item',
            'ZHIHUISHU_QZMD',
            index === 1 ? 'm_l15' : '',
          ]"
          v-for="(item, index) in deleteOperationList"
          :key="item.title"
          :style="{
            backgroundColor: item.bgc,
            border: item.border,
            color: item.color,
          }"
          @click="deleteOperationItemClick(item)"
        >
          {{ item.title }}
        </div>
      </div>
      <div class="loading_mask" v-if="dialogLoadingForDelete">
        <a-spin />
      </div>
    </div>
  </my-dialog>
</template>

<script>
// 用的地方太多 实在忍不了了 抽离封装一下
export default {
  components: {
    'my-dialog': () => import('./my_dialog'),
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    tipMsg: {
      type: String,
      default: '删除后无法恢复，请谨慎操作',
    },
  },
  data() {
    return {
      dialogFlagForDelete: false,
      dialogLoadingForDelete: false,
      deleteOperationList: [
        {
          title: '确定删除',
          bgc: '#FFF',
          border: '1px solid #D9D9D9',
          color: '#595959',
          type: 0,
        },
        {
          title: '取消删除',
          bgc: '#2090FF',
          border: 'none',
          color: '#FFF',
          type: 1,
        },
      ],
    }
  },
  watch: {
    showModal(newVal, oldVal) {
      this.dialogFlagForDelete = newVal
    },
  },
  methods: {
    closeModal() {
      this.$emit('update:showModal', false)
    },
    // delete：
    async deleteOperationItemClick({ type }) {
      switch (type) {
        case 0:
          this.$emit('delete')
          this.$emit('update:showModal', false)
          break
        case 1:
          this.closeModal()
          break
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin dialogTitle($color) {
  width: 100%;
  height: 60px;
  line-height: 60px;
  font-weight: bold;
  color: $color;
  font-size: 16px;
  border-radius: 10px 10px 0 0;
  padding: 0 30px;
  border-bottom: 1px solid #e7e7e7;
}
@mixin verticalAndCrosswiseCenter {
  display: flex;
  justify-content: center;
  align-items: center;
}
@keyframes scaleCircle {
  from {
    transform: translate(-50%, -50%) scale(0);
  }
  to {
    transform: translate(-50%, -50%) scale(100);
  }
}
// delete:
.dialog_inner_container_for_delete {
  .dialog_inner_container_for_delete_header {
    @include dialogTitle(#222);
  }
  .dialog_inner_container_for_delete_body {
    padding: 15px;
    text-align: center;
  }
  .dialog_inner_container_for_delete_footer {
    width: 100%;
    height: 70px;
    padding-bottom: 23px;
    @include verticalAndCrosswiseCenter();
    .dialog_inner_container_for_delete_footer_inner_item {
      width: 74px;
      height: 32px;
      @include verticalAndCrosswiseCenter();
      font-size: 12px;
      color: #fff;
      border-radius: 5px;
      cursor: pointer;
      box-shadow: 0 0 5px #f5f5f5;
      transition: all 0.5s;
      letter-spacing: 1px;
      &:nth-of-type(1) {
        &:hover {
          border: 1px solid #2090ff !important;
          color: #2090ff !important;
        }
      }
      &:nth-of-type(2) {
        &:hover {
          background-color: #48a2fc;
        }
      }
    }
  }
}
</style>
